import axios from "@/axios.js";

function mapItem(item) {
  if (!item) return null;
  return { ID: item.Id, RegionId: item.RegionId, Code: item.Code, NameAr: item.NameAr, NameEn: item.NameEn, IsActive: item.IsActive };
}
function mapCreateUpdatePayload(item) {
  return { Id: item.ID || 0, RegionId: item.RegionId || 0, Code: item.Code || "", NameAr: item.NameAr || "", NameEn: item.NameEn || "", IsActive: item.IsActive !== undefined ? item.IsActive : true };
}
function getResponseData(response, fallback = null) {
  if (!response || !response.data) return fallback;
  return response.data.Data || fallback;
}
export default {
  fetchDataListItems({ commit }) {
    return new Promise((resolve, reject) => {
      axios.get("/api/City/GetAll").then((response) => {
        const raw = getResponseData(response, []);
        const payload = Array.isArray(raw) ? raw.map(mapItem) : [];
        commit("SET_ITEMS", payload);
        resolve(response);
      }).catch((error) => reject(error));
    });
  },
  addItem({ commit }, item) {
    const payloadToApi = mapCreateUpdatePayload(item);
    return new Promise((resolve, reject) => {
      axios.post("/api/City/Add", payloadToApi).then((response) => {
        const raw = getResponseData(response, payloadToApi);
        const payload = mapItem(raw);
        commit("ADD_ITEM", payload);
        resolve(response);
      }).catch((error) => reject(error));
    });
  },
  updateItem({ commit }, item) {
    const payloadToApi = mapCreateUpdatePayload(item);
    return new Promise((resolve, reject) => {
      axios.put("/api/City/Update", payloadToApi).then((response) => {
        const raw = getResponseData(response, payloadToApi);
        const payload = mapItem(raw);
        commit("UPDATE_ITEM", payload);
        resolve(response);
      }).catch((error) => reject(error));
    });
  },
  removeItem({ commit }, item) {
    const id = item && item.ID ? item.ID : item;
    return new Promise((resolve, reject) => {
      axios.delete("/api/City/Delete/" + id).then((response) => {
        commit("REMOVE_ITEM", id);
        resolve(response.data || response);
      }).catch((error) => reject(error));
    });
  },

  fetchCitiesByRegion({ commit }, regionId) {
  return new Promise((resolve, reject) => {
    axios.get(`/api/City/GetByRegionId/${regionId}`)
      .then((response) => {
        const data = response.data.data || response.data.Data;
        commit('SET_ITEMS', Array.isArray(data) ? data : [data]);
        resolve(response);
      }).catch((err) => reject(err));
  });
}
};
